import MagicLinkEmailForm from './MagicLinkEmailForm';

export default MagicLinkEmailForm;
